export const CHANGE_STATUS = 'CHANGE_STATUS';
export const CHECKING_PROGRESS = 'CHECKING_PROGRESS';
export const INITIAL_DATA_FLOW = 'INITIAL_DATA_FLOW';
export const INITIAL_DISPUTE_DATA_FLOW = 'INITIAL_DISPUTE_DATA_FLOW';
export const UPDATE_DISPUTE_DATA_FLOW = 'UPDATE_DISPUTE_DATA_FLOW';
export const RESET_CHECKING_PROGRESS = 'RESET_CHECKING_PROGRESS';
export const INITIAL_DISPUTE_PHOTO_DATA = 'INITIAL_DISPUTE_PHOTO_DATA';
